/* eslint-disable */

/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";


import { drawer } from './modules/drawer'
import { users } from './modules/users'
import { shops } from './modules/shops'
import { categories } from './modules/categories'
import { products } from './modules/products'
import { dialogs } from './modules/dialogs'
import { transactions } from './modules/transactions'
import { providers } from './modules/providers'
import { summary } from './modules/summary'
import { bills } from './modules/bills'
import { subscriptions } from './modules/subscriptions'
import { parsers } from './modules/parsers'
import { loading } from './modules/loading'
import { admins } from './modules/admins'
import { returns } from './modules/returns'
import { idle } from './modules/idle'
import { payment } from './modules/payment'
import { pos } from './modules/pos'
import { notifications } from './modules/notifications'
import { clients } from './modules/clients'
import { marketplace } from './modules/marketplace'
import { storefront } from './modules/storefront'
import { plans } from './modules/plans'
import { referrals } from './modules/referrals'
import { promotions } from './modules/promotions'
import { cms } from './modules/cms'
import { delivery } from './modules/delivery'
import { admin } from './modules/admin'
import { restaurant } from './modules/restaurant'
import * as firebase from 'firebase'
import { fireDb, auth, GoogleProvider } from '../plugins/auth/firebase.js'

global.firebase = firebase


Vue.use(Vuex)
const dataState = createPersistedState({
  paths: ['users','shops',]
})
// Create a new store
export default new Vuex.Store({
  modules: {
    drawer,
    users,
    shops,
    categories,
    products,
    transactions,
    dialogs,
    providers,
    bills,
    parsers,
    subscriptions,
    loading,
    admins,
    summary,
    returns,
    idle,
    payment,
    pos,
    notifications,
    marketplace,
    clients,
    storefront,
    plans,
    referrals,
    promotions,
    cms,
    delivery,
    admin,
    restaurant
  },
  plugins: [dataState]
})
